import { render } from "./ReservationConfirmation.vue?vue&type=template&id=5f7df143&scoped=true"
import script from "./ReservationConfirmation.vue?vue&type=script&lang=js"
export * from "./ReservationConfirmation.vue?vue&type=script&lang=js"

import "./ReservationConfirmation.vue?vue&type=style&index=0&id=5f7df143&scoped=true&lang=css"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7df143"]])

export default __exports__